// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const depreciationModelSchema = z.enum([
  'STRAIGHT_LINE',
  'DOUBLE_DECLINING',
  'SUM_YEAR',
  'UNIT_OF_PRODUCTION',
]);

export type DepreciationModel = z.infer<typeof depreciationModelSchema>;

export const DEPRECIATION_MODEL_LABELS: Record<DepreciationModel, string> = {
  STRAIGHT_LINE: 'Straight line',
  DOUBLE_DECLINING: 'Double-declining balance',
  SUM_YEAR: "Sum-of-the-Years' digits",
  UNIT_OF_PRODUCTION: 'Unit of production',
};
